<template>
  <div class="wrapper index">
    <div class="main box-padding">
      <div class="col-xs-4"><a @click="$router.push({name: 'index'})"><img src="../../assets/img/main/logo-white.png" alt="念相" class="logo"></a></div>
      <div class="col-xs-pull-1 m-index-text-right">
        <div class="m-index-change-lang">
          <a @click="changeLocale('en')" class="m-index-a">EN</a>
          <span>|</span>
          <a @click="changeLocale('zh_cn')" class="m-index-a">CN</a>
        </div>
        <img src="../../assets/img/icon/nav-white.png" alt="" class="nav-toggle" @click="openNav">
      </div>
      <div class="text col-xs-12">
        <ul>
          <li><img src="../../assets/img/mindex/text1-1.png" alt="" width="78.57%"><div class="text1"></div></li>
          <li><img src="../../assets/img/mindex/text21.png" alt="" width="45.37%"><div class="text2"></div></li>
          <li><img src="../../assets/img/mindex/text31.png" alt="" width="47.59%"><div class="text3"></div></li>
          <li><img src="../../assets/img/mindex/text4-1.png" alt="" width="77.77%"><div class="text4"></div></li>
        </ul>
        <img src="../../assets/img/mindex/text5-new.png" alt="" width="90%">
      </div>
    </div>
  </div>
</template>
<script type="text/ecmascript-6" lang="babel">
  import $ from 'jquery';
  import hub from '../../utils/hub';

  export default {
    methods: {
      openNav() {
        hub.$emit('open-nav');
      },
      changeLocale(lang) {
        this.$i18n.locale = lang;
        const { name } = this.$route;
        this.$router.push({ name, params: { lang } });
      }
    },
    mounted() {
      const scale = document.documentElement.clientWidth / 640;
      $('.index .text div').css('transform', `scale(${scale})`);
    }
  };
</script>
<style type="text/css">
  .m-index-a{
    cursor: pointer;
    display: inline-block;
    vertical-align: middle;
    padding-top: 1px;
  }
</style>



// WEBPACK FOOTER //
// src/pages/index/m-index.vue